import {
  booleanAttribute,
  Directive,
  ElementRef,
  inject,
  input,
  output,
} from '@angular/core';

@Directive({
  selector: '[iwClickOutside]',
  host: {
    '(document:click)': 'onDocEvent($event)',
    '(document:touchstart)': 'onDocEvent($event)',
  },
})
export class ClickOutsideDirective {
  readonly #el = inject<ElementRef<HTMLElement>>(ElementRef);

  readonly enabled = input(false, { transform: booleanAttribute });

  readonly clickOutside = output<MouseEvent | TouchEvent>();

  onDocEvent(event: MouseEvent | TouchEvent): void {
    if (!this.enabled()) return;

    const target = event.target as HTMLElement | null;
    if (!target) return;

    const host = this.#el.nativeElement;
    if (host.contains(target)) return;

    if (target.closest('.cdk-overlay-backdrop, .fu-dropdown')) return;

    this.clickOutside.emit(event);
  }
}
